const data = {
  photographys: [
      {
        id: 1,
        title: 'Mooning Nancy lightbox installation at Patricia Valian Reser Center for the Creative Arts - OSU',
        description: "printed on illumisol, backlit lightbox installation, dimensions vary",
        image: require("./../img/photography/MN_Prax_01.JPG"),
      },
      {
        id: 2,
        title: 'Mooning Nancy lightbox installation at Patricia Valian Reser Center for the Creative Arts - OSU',
        description: "printed on illumisol, backlit lightbox installation, dimensions vary",
        image: require("./../img/photography/MN_Prax_02.JPG"),
      },
      {
        id: 3,
        title: 'Mooning Nancy lightbox installation at Patricia Valian Reser Center for the Creative Arts - OSU',
        description: "printed on illumisol, backlit lightbox installation, dimensions vary",
        image: require("./../img/photography/MN_Prax_03.JPG"),
      },
      {
        id: 4,
        title: 'Mooning Nancy lightbox installation at Patricia Valian Reser Center for the Creative Arts - OSU',
        description: "printed on illumisol, backlit lightbox installation, dimensions vary",
        image: require("./../img/photography/MN_Prax_04.JPG"),
      },
    {
        id: 5,
        title: 'Spellcasting Salt batch 031920202049',
        description: "photomicroscopy animation",
        image: require("./../img/photography/Salt_01.gif"),
      },
      {
        id: 6,
        title: 'Spellcasting Salt batch 062020201443',
        description: "photomicroscopy animation",
        image: require("./../img/photography/Salt_02.gif"),
      },
      {
        id: 7,
        title: 'Spellcasting Salt batch 09222020630',
        description: "photomicroscopy animation",
        image: require("./../img/photography/Salt_03.gif"),
      },
      {
        id: 8,
        title: 'Spellcasting Salt batch 12212020202',
        description: "photomicroscopy animation",
        image: require("./../img/photography/Salt_04.gif"),
      },
      {
        id: 9,
        title: 'Spellcasting Salt batch 062020212031',
        description: "photomicroscopy animation",
        image: require("./../img/photography/Salt_05.gif"),
      },
      {
        id: 10,
        title: 'View from my back yard (Wildfire Sun, 5:36pm PST Sept.9, 2020)',
        description: "Archival print on photo matte paper",
        size: "32 x 40 inches",
        year: "ongoing",
        image: require("./../img/photography/WildfireSun.jpeg"),
      },
      {
        id: 11,
        title: 'View from my back yard (Total Eclipse, 10:19am PST Aug. 21, 2017)',
        description: "archival pigment print on luster",
        size: "33 x 48 inches",
        year: "ongoing",
        image: require("./../img/photography/TotalEclipse.jpg"),
      },
      {
        id: 12,
        title: 'View from my back yard (Lunar Eclipse, 8:21am PST Apr. 15, 2014)',
        description: "archival pigment print on luster",
        size: "33 x 48 inches",
        year: "ongoing",
        image: require("./../img/photography/WildfireMoon.jpg"),
      },
      {
        id: 13,
        title: 'View from my back yard (Total Eclipse, 2:02pm CST Apr. 8, 2024)',
        description: "archival pigment print on luster",
        size: "33 x 48 inches",
        year: "ongoing",
        image: require("./../img/photography/TotalEclipse-IN.jpg"),
      },
            {
        id: 14,
        title: 'View from my back yard (Lunar Eclipse, 9:12pm PST Aug. 27, 2026)',
        description: "archival pigment print on luster",
        size: "33 x 48 inches",
        year: "ongoing",
        image: require("./../img/photography/LunarEclipse.jpg"),
      },
      {
        id: 15,
        title: 'The Sun Tunnels',
        description: "long-exposure digital photograph",
        // size: "24 x 16 inches",
        image: require("./../img/photography/TS2_01.jpg"),
      },
      {
        id: 16,
        title: 'The Sun Tunnels - Summer Solstice',
        description: "digital photograph",
        // size: "24 x 16 inches",
        image: require("./../img/photography/TS2_summer-solstice.jpg"),
      },
      {
        id: 17,
        title: 'Suttle Lake Reflections No. 1',
        description: "archival pigment print on luster",
        size: "24 x 16 inches",
        image: require("./../img/photography/suttle_02.jpg"),
      },
      {
        id: 18,
        title: 'Suttle Lake Reflections No. 2',
        description: "archival pigment print on luster",
        size: "24 x 16 inches",
        image: require("./../img/photography/suttle_01.jpg"),
      },
      {
        id: 19,
        title: 'Suttle Lake Reflections No. 3',
        description: "archival pigment print on luster",
        size: "24 x 16 inches",
        image: require("./../img/photography/suttle_03.jpg"),
      },
      {
        id: 20,
        title: 'Suttle Lake Reflections No. 4',
        description: "archival pigment print on luster",
        size: "16 x 24 inches",
        image: require("./../img/photography/suttle_04.jpg"),
      },
      {
        id: 21,
        title: 'Suttle Lake Reflections No. 5',
        description: "archival pigment print on luster",
        size: "16 x 24 inches",
        image: require("./../img/photography/suttle_05.jpg"),
      },

      
  ],
};

export default data;